import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = ({ darkMode, toggleDarkMode }) => {
  const location = useLocation();

  const isActive = path => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname.startsWith('/blog');
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="header-wrapper">
      <header className="header-top">
        <nav className="nav">
          <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
            Writing
          </Link>
          <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`}>
            About
          </Link>
          <Link to="/projects" className={`nav-link ${isActive('/projects') ? 'active' : ''}`}>
            Projects
          </Link>
          <Link to="/now" className={`nav-link ${isActive('/now') ? 'active' : ''}`}>
            Now
          </Link>
        </nav>
        <div className="header-actions">
          <Link
            to="/reading-list"
            className="reading-list-link"
            aria-label="Reading list"
            title="Reading list"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
            </svg>
          </Link>
          <button
            className="dark-mode-toggle"
            onClick={toggleDarkMode}
            aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {darkMode ? (
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="5" />
                <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
              </svg>
            ) : (
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
              </svg>
            )}
          </button>
        </div>
      </header>
      <div className="header-topics">
        <div className="header-topics-inner">
          <span className="header-topics-label">Topics</span>
          <Link
            to="/startup-fundamentals"
            className={`header-topic-link ${isActive('/startup-fundamentals') ? 'active' : ''}`}
          >
            Startup Fundamentals
          </Link>
          <Link
            to="/fundraising"
            className={`header-topic-link ${isActive('/fundraising') ? 'active' : ''}`}
          >
            Fundraising
          </Link>
          <Link
            to="/nordic"
            className={`header-topic-link ${isActive('/nordic') ? 'active' : ''}`}
          >
            The Nordic Edge
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
